import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "../../Components/Newsletter/Newsletter";
// import "./section.css";

export default function SkillPage() {
  return (
    <>
      <Link to="/contact">
        <div
          className=" w-full h-screen bg-no-repeat bg-cover bg-fixed md:w-32 lg:w-48	"
          Style="background-image: url('./image/full-stack-development.gif')"
        >
        </div>
      </Link>
      <div
        className=" w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/home3.gif')"
      >
      </div>
      <div
        className=" w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/app1.gif')"
      >
      </div>

      <Newsletter />
    </>
  );
}
